export default (renderers) => {
  const rendererToModel = {};
  const Renderer = {};

  Object.keys(renderers).forEach((name) => {
    const modelName = name.split('-')[0];
    rendererToModel[name] = modelName;
  });

  Renderer.s = renderers;
  Renderer.mapToModel = rendererToModel;

  Renderer.render = parsing => Promise.resolve(parsing).then((parsed) => {
    const { modelName, settings } = parsed;
    const defaultRenderer = renderers[`${modelName}-default`];
    const renderer = renderers[settings[`rendererFor-${modelName}`]];
    return Promise.resolve((renderer || defaultRenderer).render(parsed));
  });

  return Renderer;
};
